import { useQuery } from '@tanstack/react-query';
import { fetchApi } from '../lib/api';
import type { EnrollmentWithSubject } from '@repo/shared-types';

/** Enrollments in a subject — the roster picker source (gives enrollmentId
 *  directly). Defaults to ACTIVE-only, every existing caller's assumption;
 *  pass `status: null` for every status in one call (the API's own
 *  `?subjectId=` with no `status` omits the filter entirely) — THI-267 Task
 *  13's AddMembersDialog needs PAUSED enrollments too, to exclude a paused
 *  student's row rather than silently treating them as unenrolled. */
export function useEnrollmentsForSubject(subjectId: string | null, status: 'ACTIVE' | null = 'ACTIVE') {
  return useQuery<EnrollmentWithSubject[]>({
    queryKey: ['enrollments', { subjectId, status }],
    queryFn: () => fetchApi(`/enrollments?subjectId=${subjectId}${status ? `&status=${status}` : ''}`),
    enabled: !!subjectId,
  });
}
